/**
 * BulbIcon — issue #438 visual system. Lightbulb glyph for hint
 * buttons and feature callouts. Tree-shakable via direct import:
 *
 *   import { BulbIcon } from './icons/BulbIcon';
 *
 * Accepts `size` (default 20) and `className`. Omit `aria-label` to
 * mark the icon as decorative (`aria-hidden="true"` by default); supply
 * `aria-label` to render as a labelled image with `role="img"`.
 */
import type { ReactElement } from 'react';
import type { IconProps } from './iconTypes';
import { SHARED_ICON_ATTRS } from './iconTypes';

export function BulbIcon({ size = 20, className, ...rest }: IconProps): ReactElement {
  const aria = rest['aria-label']
    ? { role: 'img' as const, 'aria-label': rest['aria-label'] }
    : { 'aria-hidden': true };
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      {...SHARED_ICON_ATTRS}
      {...aria}
      {...className ? { className } : undefined}
      {...rest}
    >
      <path d="M9 18h6" />
      <path d="M10 22h4" />
      <path d="M12 2a7 7 0 0 0-7 7c0 2.38 1.19 4.47 3 5.74V17a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2.26c1.81-1.27 3-3.36 3-5.74a7 7 0 0 0-7-7z" />
    </svg>
  );
}
